import { ValidatePhoneFunc } from "./challenges/challenge";
import { ChallengerLocalization, ChallengerLocalizationMap, DefaultLocalizationMap } from "./localizations";
import { HoneypotStyles } from "./structs";

const GlobalDefaultLang = "en-US";

// ChallengerConf - This class hosts the details that will only be set at the start of a ChallengerCore.  Most ChallengerCores will use the same configuration.
export class ChallengerConf {
    lang: string;
    defaultLang: string;
    localizationMap: ChallengerLocalizationMap;

    capi: string;
    capi_refreshPng: string;
    trackingID: string;
    param: Record<string, unknown> | string;

    challengerRefreshMS: number;
    challengerRefreshMSOnFail: number;
    challengerRefreshOnFailRetryMaxCount: number;

    challengeRenderRetryMS: number;
    challengeRenderRetryMaxCount: number;

    custom_validate_phone: ValidatePhoneFunc | null;

    honeypotShadowDom: boolean; // Flag to determine if honeypot will be rendered inside its own shadow root
    honeypotStyles: HoneypotStyles | undefined;

    constructor(
        challengerUrl: string,
        lang: string,
        trackingID: string,
        param: Record<string, unknown>,
        defaultLang: string = GlobalDefaultLang,
        challengerRefreshS = 60,
        challengerRefreshSOnFail = 1,
        challengerRefreshOnFailRetryMaxCount = 3,
        challengeRenderRetryS = 1,
        challengeRenderRetryMaxCount = 5,
        challengerUrlVersion = "v1.0",
        challengerLocalizationMap: ChallengerLocalizationMap = DefaultLocalizationMap,
        validatePhoneFunc: ValidatePhoneFunc | null = null,
        honeypotShadowDom = true,
        honeypotStyles: HoneypotStyles | undefined
    ) {
        this.capi = `${challengerUrl}/${challengerUrlVersion}`;
        this.capi_refreshPng = `${challengerUrl}/static/refresh.png`;
        this.trackingID = trackingID || "";
        this.param = param || {};

        this.challengerRefreshMS = challengerRefreshS * 1000;
        this.challengerRefreshMSOnFail = challengerRefreshSOnFail * 1000;
        this.challengerRefreshOnFailRetryMaxCount = challengerRefreshOnFailRetryMaxCount;

        this.challengeRenderRetryMS = challengeRenderRetryS * 1000;
        this.challengeRenderRetryMaxCount = challengeRenderRetryMaxCount;

        this.localizationMap = challengerLocalizationMap ?? DefaultLocalizationMap;
        this.setLang(lang, defaultLang);
        this.custom_validate_phone = validatePhoneFunc;
        this.honeypotShadowDom = honeypotShadowDom;
        this.honeypotStyles = honeypotStyles;
    }

    // setLang - coallesces input languages into something that is currently valid
    setLang(lang: string, defaultLang: string): void {
        if (!this.localizationMap.has(defaultLang)) {
            defaultLang = GlobalDefaultLang;
        }
        if (!this.localizationMap.has(lang)) {
            lang = defaultLang;
        }
        this.lang = lang;
        this.defaultLang = defaultLang;
    }

    // getLocalization - gets the Localization file for Challenger by first coallescing the langugage
    getLocalization(): ChallengerLocalization {
        this.setLang(this.lang, this.defaultLang);
        return this.localizationMap.get(this.lang) || new ChallengerLocalization();
    }
}
